import _classCallCheck from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/montri/Desktop/Work/anthr/anthr-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
/**
 * DevExtreme (esm/ui/context_menu/ui.menu_base.edit.strategy.js)
 * Version: 22.2.11
 * Build date: Fri Feb 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import $ from "../../core/renderer";
import { map } from "../../core/utils/iterator";
import PlainEditStrategy from "../collection/ui.collection_widget.edit.strategy.plain";
var MenuBaseEditStrategy = /*#__PURE__*/function (_PlainEditStrategy) {
  _inherits(MenuBaseEditStrategy, _PlainEditStrategy);
  function MenuBaseEditStrategy() {
    _classCallCheck(this, MenuBaseEditStrategy);
    return _possibleConstructorReturn(this, _getPrototypeOf(MenuBaseEditStrategy).apply(this, arguments));
  }
  _createClass(MenuBaseEditStrategy, [{
    key: "_getPlainItems",
    value: function _getPlainItems() {
      return map(this._collectionWidget.option("items"), function getMenuItems(item) {
        return item.items ? [item].concat(map(item.items, getMenuItems)) : item;
      });
    }
  }, {
    key: "_stringifyItem",
    value: function _stringifyItem(item) {
      var _this = this;
      return JSON.stringify(item, function (key, value) {
        if ("template" === key) {
          return _this._getTemplateString(value);
        }
        return value;
      });
    }
  }, {
    key: "_getTemplateString",
    value: function _getTemplateString(template) {
      var result;
      if ("object" === typeof template) {
        result = $(template).text();
      } else {
        result = template.toString();
      }
      return result;
    }
  }]);
  return MenuBaseEditStrategy;
}(PlainEditStrategy);
export default MenuBaseEditStrategy;